import { render, staticRenderFns } from "./EnergyFlame.vue?vue&type=template&id=c09e0752&"
import script from "./EnergyFlame.vue?vue&type=script&lang=js&"
export * from "./EnergyFlame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports